export default __webpack_public_path__ + "static/media/logo_noBg_v1_3.c6b4be8e.jp2";